import React, { useState, useEffect } from 'react';
import { firestore } from '../config/firebaseConfig'; 
import { collection, addDoc, updateDoc, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';
import { MdEditNote, MdDeleteForever, MdSave, MdCancel } from 'react-icons/md';


import './Temas.css';

function Temas() {
  const [temas, setTemas] = useState([]);
  const [nome, setNome] = useState('');
  const [editId, setEditId] = useState(null);
  const [editingNome, setEditingNome] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const tenantId = localStorage.getItem('tenantId'); 

  useEffect(() => {
    if (tenantId) {
      fetchTemas();
    }
  }, [tenantId]);

  const fetchTemas = async () => {
    try {
      const temasRef = collection(firestore, 'temas');
      const q = query(temasRef, where('tenantId', '==', tenantId));
      const querySnapshot = await getDocs(q);
      const temasData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTemas(temasData);
    } catch (error) {
      console.error('Erro ao buscar temas:', error);
      setError('Não foi possível carregar os temas.');
    }
  };

  const handleAddOrUpdate = async (e) => {
    e.preventDefault();
    if (!nome.trim()) {
      setError('Por favor, insira o nome do tema.');
      return;
    }

    try {
      const temasRef = collection(firestore, 'temas');
      if (editId) {
        const temaRef = doc(firestore, 'temas', editId);
        await updateDoc(temaRef, { nome: nome.trim() });
        setSuccess('Tema atualizado com sucesso!');
        setEditId(null);
      } else {
        const q = query(temasRef, where('tenantId', '==', tenantId), where('nome', '==', nome.trim()));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          setError('Este tema já existe.');
          return;
        }

        await addDoc(temasRef, { nome: nome.trim(), tenantId });
        setSuccess('Tema adicionado com sucesso!');
      }

      setNome('');
      fetchTemas();

      // Remover a mensagem de sucesso após 3 segundos
      setTimeout(() => setSuccess(''), 3000);

    } catch (error) {
      console.error('Erro ao adicionar/atualizar tema:', error);
      setError('Houve um problema ao salvar o tema. Por favor, tente novamente.');
    }
  };

  const handleEditClick = (tema) => {
    setEditId(tema.id);
    setEditingNome(tema.nome);
    setSuccess('');
    setError('');
  };

  const handleSaveClick = async () => {
    try {
      const temaRef = doc(firestore, 'temas', editId);
      await updateDoc(temaRef, { nome: editingNome.trim() });
      setEditId(null);
      setSuccess('Tema atualizado com sucesso!');
      fetchTemas();

      // Remover a mensagem de sucesso após 3 segundos
      setTimeout(() => setSuccess(''), 3000);

    } catch (error) {
      console.error('Erro ao salvar o tema:', error);
      setError('Houve um problema ao atualizar o tema.');
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(firestore, 'temas', id));
      setSuccess('Tema removido com sucesso!');
      fetchTemas();

      // Remover a mensagem de sucesso após 3 segundos
      setTimeout(() => setSuccess(''), 3000);

    } catch (error) {
      console.error('Erro ao remover tema:', error);
      setError('Houve um problema ao remover o tema. Por favor, tente novamente.');
    }
  };

  return (
    <div className="manage-temas-container">
      <h2>Manutenção dos Temas</h2>
      <form onSubmit={handleAddOrUpdate} className="add-tema-form">
        <input
          type="text"
          placeholder="Novo Tema"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          required
        />
        <button type="submit">{editId ? 'Atualizar' : 'Adicionar'}</button>
      </form>
      {error && <div className="form-feedback form-error">{error}</div>}
      {success && <div className="form-feedback form-success">{success}</div>}

      
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Tema</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {temas.map(tema => (
              <tr key={tema.id} className={editId === tema.id ? 'editing-row' : ''}>
                <td>
                  {editId === tema.id ? (
                    <input
                      type="text"
                      className="edit-input"
                      value={editingNome}
                      onChange={(e) => setEditingNome(e.target.value)}
                    />
                  ) : (
                    tema.nome
                  )}
                </td>
                <td className="actions">
                  {editId === tema.id ? (
                    <>
                      <MdSave size="28" className="action-icon save-icon" onClick={handleSaveClick} title="Salvar" />
                      <MdCancel size="28" className="action-icon cancel-icon" onClick={() => setEditId(null)} title="Cancelar" />
                    </>
                  ) : (
                    <>
                      <MdEditNote size="28" className="action-icon edit-icon" onClick={() => handleEditClick(tema)} title="Editar" />
                      <MdDeleteForever size="28" className="action-icon delete-icon" onClick={() => handleDelete(tema.id)} title="Remover" />
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Temas;
